// extracted by mini-css-extract-plugin
export default {"wrapper":"Popper_wrapper__K+K0e"};